import script from "./RegisterAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterAgreement.vue?vue&type=script&setup=true&lang=js"

import "./RegisterAgreement.vue?vue&type=style&index=0&id=0d3c8239&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3c8239"]])

export default __exports__